<div class="background-color"></div>
<img id="img-background" style="display: none" [src]="backgroundUrl" *ngIf="backgroundUrl" (load)="setTransition()"/>
<div id="div-background" [class]="imageClass" *ngIf="backgroundUrl" [ngStyle]="{'background-image': 'url(' + backgroundUrl + ')'}"></div>